import cx from "classnames"
import { Link as GatsbyLink } from "gatsby"
import _map from "lodash/map"
import _toLower from "lodash/toLower"
import React from "react"
import { Link as Scrolllink } from 'react-scroll'
import * as styles from "./styles.module.css"

interface ItemsProps {
  menuItems: { label: string; button: boolean; url: string; type: string }[]
  setNavbarOpen: (state: boolean) => void
  isMobile?: boolean
  innerHeight?: number
  activeMenu?: string
}

const ItemsMenu = ({
  menuItems,
  setNavbarOpen,
  isMobile,
  innerHeight,
  activeMenu,
}: ItemsProps) => {
  const anchorClasses = cx(
    "sm:mx-0 lg:mx-3 flex items-center hover:text-cyan text-base font-light leading-snug text-white hover:font-bold hover:border-b-4 hover:border-cyan "
  )

  const buttonClasses = cx(
    "bg-cyan py-3 px-8 text-elephant cursor-pointer font-bold sm:text-sm md:text-base hover:text-black hover:bg-opacity-80 lg:ml-3",
    styles.button
  )

  return (
    <>
      {_map(menuItems, (item, key) => {
        if (item.type === "redirect") {
          return (
            <div className="sm:pt-12 lg:mt-0 lg:p-0 lg:ml-3" key={key}>
              <GatsbyLink
                to={
                  _toLower(activeMenu) === _toLower(item.label)
                    ? ""
                    : (item.label === 'Vagas' ? `${item.url}` : `/${item.url}`)
                }
                className={cx(item.button ? buttonClasses : anchorClasses, {
                  "border-b-4 border-cyan":
                    _toLower(activeMenu) === _toLower(item.label),
                })}
              >
                {item.label}
              </GatsbyLink>
            </div>
          )
        }
        if (item.type === "redirectScroll") {
          return (
            <div className="sm:pt-12 lg:mt-0 lg:p-0 lg:ml-3" key={key}>
              {typeof window !== "undefined" && window.location.pathname === "/" ? (
                <Scrolllink
                  to={item.url}
                  onClick={(e) => {
                    e.preventDefault();
                    setNavbarOpen(false);
                    // ao clicar limpa o hash da url
                    window.history.pushState("", document.title, window.location.pathname);
                  }}
                  smooth={true}
                  duration={1000}
                  delay={200}
                  offset={isMobile ? innerHeight : 0}
                  className={item.button ? buttonClasses : anchorClasses}
                >
                  {item.label}
                </Scrolllink>
              ) : (
                <a className={item.button ? buttonClasses : anchorClasses} href={typeof window !== "undefined" ? (window.location.origin + "/#" + item.url) : ""}>{item.label}</a>
              )}
            </div>
          )
        }
      })}
    </>
  )
}

export default ItemsMenu